import React from "react";
import { useHeader } from "./useHeader.ts";
import { HeaderModal } from "./HeaderModal";

export default function Header() {
  const { toggleExitModal, showModal, handleExit } = useHeader();

  return (
    <>
      <header className="ac-header">
        <div className="ch-row ch-ml--5">
          <div className="xs:ch-col--8 md:ch-col--4 page-layout--content-compact">
            <span
              className="ac-brand ac-brand--header header-link"
              onClick={toggleExitModal}
            >
              <span className="ch-reader">Arnold Clark</span>
            </span>
          </div>
        </div>
      </header>
      <HeaderModal
        show={showModal}
        modalCopy="Your progress will be lost, are you sure you want to exit?"
        handleClose={toggleExitModal}
        handleExit={handleExit}
        handleExitCopy="Exit"
        customOverlayStyles={{ background: "rgba(0,0,0, 0.5)" }}
      />
    </>
  );
}
